import { IRestaurant, IRestaurantArea, ITablePlan, Pill } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Path } from '../../enums';
import { PathUtils } from '../../utils';
import { TablePlanThumbnail } from './TablePlanThumbnail';

interface IProps {
    restaurant?: IRestaurant;
    area: IRestaurantArea;
    tablePlan: ITablePlan;
}

const TablePlanCard: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(
            PathUtils.generateUrl(Path.RESTAURANT_TABLE_PLAN_DETAILS, {
                restaurantId: props.restaurant?.id,
                tablePlanId: props.tablePlan.id,
            }),
        );
    };

    const tables = props.tablePlan.tables?.length ?? 0;
    const seats = props.tablePlan.tables?.reduce((total, table) => total + (table.numberOfSeats || 0), 0) ?? 0;

    const inUse = Boolean(props.area.areaShifts?.some((shift) => shift.tablePlanId === props.tablePlan.id));

    return (
        <div
            className="table-plan-card"
            role="button"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleClick();
                }
            }}
        >
            <div className="table-plan-card__thumb">
                <TablePlanThumbnail tablePlan={props.tablePlan} />
            </div>
            <div className="table-plan-card__body">
                <span className="table-plan-card__name">{props.tablePlan.name}</span>
                <span className="table-plan-card__meta">
                    {[t('table.plans.tablesCount', { count: tables }), t('table.plans.seatsCount', { count: seats })]
                        .filter(Boolean)
                        .join(' · ')}
                </span>
                <span className="table-plan-card__area">{props.area.name}</span>
                <div className="table-plan-card__status">
                    <Pill
                        tone={inUse ? 'good' : 'neutral'}
                        label={inUse ? t('table.plans.inUse') : t('table.plans.notInUse')}
                    />
                </div>
            </div>
        </div>
    );
};

export default TablePlanCard;
